// Importing required components and modules
import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import { Outlet } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";

const Dashboard = () => {
  return (
    <div>
      <Header />
      <div style={{display:"flex"}}>
        <Outlet />
      </div>
      <Footer />
    </div>
  );
};

export default Dashboard;
